<template>
    <div class="relative min-h-screen overflow-hidden">
        <!-- Background Image with multiply blend effect -->
        <div class="fixed inset-0 -z-30">
            <img src="/assets/photo.jpg" alt="Background" class="w-full h-full object-cover opacity-50 bg-image-animate" />
        </div>
        
        <!-- Primary multiply blend overlay for rich color interaction -->
        <div class="fixed inset-0 -z-20 bg-gradient-to-br from-blue-900/70 via-blue-900/70 to-gray-900/70 mix-blend-multiply"></div>
        
        <!-- Secondary overlay for better text readability -->
        <div class="fixed inset-0 -z-10 bg-black/40 backdrop-blur-[2px]"></div>
        

        <div v-if="formID && formFields" class="bg-white/95 shadow-2xl backdrop-blur-sm border border-white/20 m-4 mt-4 rounded-3xl relative z-10 max-w-2xl mx-auto">

        <img v-if="capturedImageUrl" :src="capturedImageUrl" class="w-full rounded-t-3xl p-2 pb-0" />

        <button v-if="!capturedImageBlob" type="button" @click="emitOpenModal" class="m-4 text-left p-2">

            <span class="flex">

                <span class="relative flex h-3 w-2 -mr-3">
                    <span
                        class="animate-ping absolute inline-flex h-full w-full h-10 w-10 rounded-full bg-blue-400 opacity-75"></span>
                    <span class="relative inline-flex rounded-full h-3 w-3 bg-blue-600"></span>
                </span>

                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" width="24"
                    height="16" stroke="currentColor" class="flex-shrink-0 h-12 w-12 text-blue-600 dark:text-gray-200">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M6.827 6.175A2.31 2.31 0 015.186 7.23c-.38.054-.757.112-1.134.175C2.999 7.58 2.25 8.507 2.25 9.574V18a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9.574c0-1.067-.75-1.994-1.802-2.169a47.865 47.865 0 00-1.134-.175 2.31 2.31 0 01-1.64-1.055l-.822-1.316a2.192 2.192 0 00-1.736-1.039 48.774 48.774 0 00-5.232 0 2.192 2.192 0 00-1.736 1.039l-.821 1.316z" />
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M16.5 12.75a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM18.75 10.5h.008v.008h-.008V10.5z" />
                </svg>
                <span class="grow ml-4">
                    <span
                        class="block text-lg font-semibold hs-tab-active:text-blue-600 text-gray-800 dark:hs-tab-active:text-blue-500 dark:text-gray-200">
                        Customers photo </span>
                    <span class="block text-xs text-gray-800 dark:hs-tab-active:text-gray-200 dark:text-gray-200">
                        Upload or Capture Customer Photo
                    </span>
                </span>
            </span>
        </button>

        <button v-else type="button" @click="emitOpenModal" class="w-full bg-red-600 hover:bg-red-700 transition-all duration-300 text-left mt-4 mb-2 mx-4 px-8 py-3 rounded-full shadow-lg transform hover:scale-105" style="width: calc(100% - 2rem);"
            data-hs-overlay="#hs-vertically-centered-scrollable-modal">
            <span class="flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                    stroke="currentColor" class="w-6 h-6 text-white mr-4">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M6.827 6.175A2.31 2.31 0 015.186 7.23c-.38.054-.757.112-1.134.175C2.999 7.58 2.25 8.507 2.25 9.574V18a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9.574c0-1.067-.75-1.994-1.802-2.169a47.865 47.865 0 00-1.134-.175 2.31 2.31 0 01-1.64-1.055l-.822-1.316a2.192 2.192 0 00-1.736-1.039 48.774 48.774 0 00-5.232 0 2.192 2.192 0 00-1.736 1.039l-.821 1.316z" />
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M16.5 12.75a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM18.75 10.5h.008v.008h-.008V10.5z" />
                </svg>
                <span class="grow">
                    <span class="block text-lg font-bold text-white">
                        Edit customers photo</span>
                    <span class="block text-xs text-white/70">
                        or Upload or Capture New Customer Photo
                    </span>
                </span>
            </span>
        </button>



        <form v-if="formFields.length > 0" @submit.prevent="submitForm" class="pt-3 transition-height ease-out duration-300"
            :class="{ 'border-t border-gray-200 border-t-2': !capturedImageBlob }">

            <div v-for="(field, index) in formFields" :key="field.id" class="p-2 py-0">
                <div v-if="field.type !== 'FILEUPLOAD'" class="relative text-left m-[-1px] px-3 pt-2.5 pb-1.5 ">

                    <div class="relative z-0">


                        <input v-if="field.type === 'TEXT' || field.type === 'EMAIL' || field.type === 'PHONE'"
                            :name="field.type" :id="`${field.id}-${index}`" autocomplete="off"
                            class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-200 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                            placeholder=" " v-model="formData[field.inputName]" :required="isRequiredField(field.label)"
                            :class="{ 'border-red-500': !emailValidation.isValid && field.type === 'EMAIL' }"
                            @blur="validateEmailOnBlur(formData[field.inputName], field.type)" />
                        <p v-if="!emailValidation.isValid && field.type === 'EMAIL'" class="text-red-500 text-xs">{{
                            emailValidation.message }}</p>
                        <textarea v-else-if="field.type === 'HTML'" :name="field.type" :id="field.type"
                            class="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6"
                            :placeholder="field.label" v-model="formData[field.id]"></textarea>
                        <div v-else-if="field.type === 'CHECKBOX'" class="checkbox-field">
                            <div class="flex items-start space-x-3">
                                <input :name="field.inputName" :id="`${field.id}-${index}`"
                                    class="mt-1 h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                                    type="checkbox" v-model="formData[field.inputName]" :required="isRequiredField(field.label)" />
                                <div class="flex-1">
                                    <label :for="`${field.id}-${index}`" class="text-sm text-gray-900 font-medium">
                                        {{ field.label }}
                                    </label>
                                    <div v-if="field.description" class="mt-2 text-sm text-gray-700 leading-relaxed">
                                        <div v-html="field.description"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else-if="field.type === 'CONSENT'" class="consent-field">
                            <div class="flex items-start space-x-3 mb-2">
                                <input :name="field.inputName" :id="`${field.id}-${index}`"
                                    class="mt-1 h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                                    type="checkbox" v-model="formData[field.inputName]" :required="isRequiredField(field.label)" />
                                <label :for="`${field.id}-${index}`" class="text-sm text-gray-900 font-medium flex-1">
                                    {{ field.checkboxLabel || field.label }}
                                </label>
                            </div>
                            <div v-if="field.description" class="w-full">
                                <div class="bg-gray-50 border border-gray-200 rounded-xl">
                                    <button type="button" 
                                        @click="toggleConsentAccordion(field.id)"
                                        class="w-full px-3 py-2 text-left text-sm text-gray-600 hover:text-gray-800 focus:outline-none flex items-center justify-between">
                                        <span>View Terms and Conditions</span>
                                        <svg :class="{ 'rotate-180': consentAccordionOpen[field.id] }" 
                                            class="w-4 h-4 transition-transform duration-200" 
                                            fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                                        </svg>
                                    </button>
                                    <div v-show="consentAccordionOpen[field.id]" 
                                        class="px-3 pb-3 border-t border-gray-200">
                                        <div class="text-sm text-gray-700 leading-relaxed consent-content" v-html="field.description">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else-if="field.type === 'RADIO'">
                            <ul class="pt-5 grid w-full gap-3 grid-cols-2">
                                <li v-for="(choice, index) in field.choices" :key="index">
                                    <input type="radio" :id="`choice_${field.id}_${index}`" :name="field.inputName"
                                        :value="choice.value" class="hidden peer" v-model="formData[field.inputName]"
                                         :checked="index === 0" />
                                    <label :for="`choice_${field.id}_${index}`"
                                        class="inline-flex items-center justify-between w-full p-2 text-gray-500 bg-white border border-gray-200 rounded-full cursor-pointer transition-all duration-200 hover:text-gray-600 hover:bg-gray-100"
                                        :class="{
                                            'peer-checked:border-red-600 peer-checked:text-red-600 peer-checked:bg-red-50': choice.value === 'No',
                                            'peer-checked:border-green-600 peer-checked:text-green-600 peer-checked:bg-green-50': choice.value === 'Yes',
                                            'peer-checked:border-blue-600 peer-checked:text-blue-600': choice.value !== 'No' && choice.value !== 'Yes'
                                        }">
                                        <div class="block">
                                            <div class="ml-4 w-full text-lg font-semibold">{{ choice.text }}</div>
                                            <div class="w-full">{{ choice.description }}</div>
                                        </div>
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                            stroke-width="4.5" stroke="currentColor" class="hidden w-5 h-5 ml-3 mr-2">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="M4.5 12.75l6 6 9-13.5" />
                                        </svg>
                                    </label>
                                </li>
                            </ul>

                        </div>

                        <!-- Add a select field -->
                        <select v-else-if="field.type === 'SELECT'" :name="field.type" :id="field.type"
                            class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-200 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                            v-model="formData[field.inputName]" :required="isRequiredField(field.label)">
                            <!-- Include the "Select an option" placeholder with an empty value -->
                            <option value="" disabled>Select an option</option>
                            <!-- Iterate over select options -->
                            <option v-for="(choice, choiceIndex) in field.choices" :key="choiceIndex" :value="choice.value">
                                {{ choice.text }}</option>
                        </select>

                        <!-- Add signature field -->
                        <div v-else-if="field.type === 'SIGNATURE'" class="signature-field">
                            <label class="block text-sm font-medium text-gray-700 mb-2">
                                {{ field.label }}
                            </label>
                            <canvas 
                                :ref="`signature_${field.id}`"
                                :id="`signature_${field.id}`"
                                class="signature-canvas border-2 border-gray-200 rounded-xl w-full h-32 cursor-crosshair"
                                @mousedown="startDrawing($event, field.id)"
                                @mousemove="draw($event, field.id)"
                                @mouseup="stopDrawing(field.id)"
                                @mouseleave="stopDrawing(field.id)"
                                @touchstart="startDrawing($event, field.id)"
                                @touchmove="draw($event, field.id)"
                                @touchend="stopDrawing(field.id)">
                            </canvas>
                            <div class="mt-2 flex justify-between">
                                <button type="button" @click="clearSignature(field.id)" 
                                    class="px-4 py-2 text-sm bg-red-600 text-white font-bold rounded-full hover:bg-red-700 transition-all duration-200 shadow-md">
                                    Clear
                                </button>
                                <span class="text-xs text-gray-500">Sign above</span>
                            </div>
                            <!-- Signature preview - HIDDEN -->
                            <!-- <div v-if="signatureData[field.id]" class="mt-2">
                                <div class="text-xs text-gray-500 mb-1">Signature Preview:</div>
                                <img :src="getSignaturePreview(field.id)" alt="Signature Preview" 
                                    class="border border-gray-200 rounded-lg max-h-16" />
                            </div> -->
                        </div>



                        <label v-if="field.type !== 'SIGNATURE' && field.type !== 'CONSENT'" :for="field.type" :class="{
                            'z-10': formData[field.inputName],
                            '-z-10': !formData[field.inputName]
                        }"
                            class="absolute text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 origin-[0] peer-focus:left-0 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">
                            {{ field.label }}
                        </label>

                    </div>
                </div>
            </div>

            <!-- Include a hidden input field to submit the capturedImageBlob -->
            <input type="hidden" name="capturedImageBlob" v-if="capturedImageUrl"
                :value="capturedImageUrl" />

            <p v-if="isBlurring && !isLoading" class="text-center text-xs text-blue-300 mb-1">Processing image...</p>
            <button type="submit" class="w-full text-center border-t border-white/20 p-4 pb-2 mt-5 mb-2" :disabled="isLoading || isSubmitting || isBlurring">

                <span v-if="isLoading">
                    <span
                        class="flex justify-center items-center grow py-3 px-8 pl-5 bg-gradient-to-r from-blue-600 to-blue-700 rounded-full hover:from-blue-700 hover:to-blue-800 transition-all duration-300 shadow-lg">
                        <!-- Loading spinner SVG here -->
                        <svg aria-hidden="true" role="status"
                            class="inline w-10 h-10 text-gray-200 animate-spin dark:text-gray-600" viewBox="0 0 100 101"
                            fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                fill="currentColor" />
                            <path
                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                fill="#1C64F2" />
                        </svg>
                        <span class="ml-4">
                            <span class="block text-md font-semibold text-white">
                                Sending Your Messages
                            </span>
                        </span>
                    </span>
                </span>
                <span v-else>
                    <span
                        class="flex justify-center items-center grow py-3 px-8 pl-5 bg-blue-600 rounded-full hover:bg-blue-700 transition-all duration-300 shadow-lg">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                            stroke="currentColor" class="flex-shrink-0 h-10 w-10 text-gray-100">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M15.59 14.37a6 6 0 01-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 006.16-12.12A14.98 14.98 0 009.631 8.41m5.96 5.96a14.926 14.926 0 01-5.841 2.58m-.119-8.54a6 6 0 00-7.381 5.84h4.8m2.581-5.84a14.927 14.927 0 00-2.58 5.84m2.699 2.7c-.103.021-.207.041-.311.06a15.09 15.09 0 01-2.448-2.448 14.9 14.9 0 01.06-.312m-2.24 2.39a4.493 4.493 0 00-1.757 4.306 4.493 4.493 0 004.306-1.758M16.5 9a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" />
                        </svg>
                        <span class="ml-4">
                            <span class="block text-md font-semibold text-white">
                                Send Your Onboarding
                            </span>
                            <span class="block text-xs text-gray-100">
                                Message Delivery
                            </span>
                        </span>
                    </span>
                </span>
            </button>
            <div class="w-full pb-2 md:pb-4 text-xs text-center text-gray-400">{{ formTitle }}</div>

        </form>

        <Loader v-if="isLoading" />

        <Modal v-if="showModal" :showModal="showModal" :modalMessage="modalMessage" @close-modal="showModal = false" />

    </div>
    </div>
</template>

  
  
<script>
import axios from 'axios';
import Modal from './Modal.vue';
import Loader from './loader.vue';
export default {
    name: 'welcome-form',
    props: {
        capturedImageBlob: Blob, // Define a prop to accept the capturedImageSrc from the parent component
        originalImageBlob: Blob, // Original (pre-blur) image for R2 storage
        formID: Number, // Define a prop to accept the form ID from the parent component
        isBlurring: { type: Boolean, default: false }, // True while background plate blur is running
    },
    computed: {
        routeSlug() {
            // Access the slug from the route params, with a fallback to ensure it doesn't error
            return this.$route && this.$route.params ? this.$route.params.slug : '';
        }
    },
    data() {
        return {
            formTitle: '',
            formFields: [],
            formData: {
                // Initialize form data properties here
                'Salesperson Name': '',
                'Buyers Name': '',
                'Buyers Email': '',
                'Mobile No:': '',
                'Special Notes': '',
                'Post to Facebook': 'Yes', // Default value
                'RadioField1': 'No', // Add separate properties for radio fields
                'RadioField2': '', // Add as many as needed
                'input_3': '', // Add this line for the Buyers Photo
            },
            isLoading: false,
            isSubmitting: false, // Prevents double form submissions
            hasLoading: false,
            showModal: false, // Control whether to show the modal
            modalMessage: '', // Message for the modal
            localCapturedImageBlob: this.capturedImageBlob,
            emailValidation: {
                isValid: true,
                message: '', // Optional, you can use this to display an error message
            },
            logoURLBLK: '/assets/engagr-blk.svg',
            capturedImageUrl: null, // Cached Object URL for capturedImageBlob
            signatureData: {}, // Store signature data for each field
            isDrawing: false,
            currentFieldId: null,
            consentAccordionOpen: {}, // Track accordion state for consent fields
        };
    },
    components: {
        Modal,
        Loader
    },
    created() {
        // Component initialization
    },
    watch: {
        capturedImageBlob: {
            handler(newVal) {
                this.localCapturedImageBlob = newVal;
                // Revoke previous Object URL to prevent memory leaks
                if (this.capturedImageUrl) {
                    URL.revokeObjectURL(this.capturedImageUrl);
                    this.capturedImageUrl = null;
                }
                if (newVal) {
                    this.capturedImageUrl = URL.createObjectURL(newVal);
                }
            },
            immediate: true
        }
    },
    methods: {
        async fetchData() {
            this.hasLoading = true; // Set isLoading to true at the beginning

            try {
                const consumerKey = 'ck_9eb5fc380da548b29cd454ad4e4e40edbf6f8aad'; // Replace with your consumer key
                const consumerSecret = 'cs_15706f39bc2a94c26ad71e695a2e730e29f6a7ae'; // Replace with your consumer secret
                const authString = btoa(`${consumerKey}:${consumerSecret}`);

                const dynamicID = this.formID; // Replace with the dynamic ID you want to use

                const response = await axios.post('https://engagr.driveagent.io/graphql', {
                    query: `
            {
                gfForm(id: ${dynamicID}, idType: DATABASE_ID) {
                    formFields {
                        nodes {
                            type
                            ... on TextField {
                            id
                            label
                            description
                            placeholder
                            }
                            ... on PhoneField {
                            id
                            label
                            description
                            placeholder
                            }
                            ... on RadioField {
                            id
                            label
                            choices {
                                value
                                text
                            }
                            description
                            }
                            ... on EmailField {
                            id
                            label
                            description
                            placeholder
                            }
                            ... on SelectField {
                            id
                            label
                            description
                            choices {
                                text
                                value
                                }
                            }
                            ... on FileUploadField {
                            id
                            label
                            description
                            }
                            ... on SignatureField {
                            id
                            label
                            description
                            }
                            ... on ConsentField {
                            id
                            label
                            description
                            checkboxLabel
                            }
                        }
                        }
                        title
  
                }
            }
        `,
                }, {
                    headers: {
                        'Authorization': `Basic ${authString}`,
                    },
                });

                const data = response.data.data.gfForm;
                this.formTitle = data.title;

                // Emit the formTitle value to the parent component
                this.$emit('update-form-title', this.formTitle);

                // Auto-map field IDs to input names
                this.formFields = data.formFields.nodes.map(field => ({
                    ...field,
                    inputName: `input_${field.id}`, // Generate input name
                }));

                // Form fields loaded successfully
            } catch (error) {
                // Handle GraphQL request errors silently in production
            } finally {
                this.hasLoading = false; // Set isLoading to false at the end
            }
        },

        async submitForm() {
            // Prevent double submissions
            if (this.isSubmitting) return;
            this.isSubmitting = true;

            try {
                // Check email fields for validity before submission
                const emailFields = this.formFields.filter(field => field.type === 'EMAIL');
                for (const emailField of emailFields) {
                    const emailValue = this.formData[emailField.inputName];
                    if (!this.validateEmail(emailValue)) {
                        this.emailValidation.isValid = false;
                        this.emailValidation.message = 'Invalid email format'; // Optional error message
                        // Display an error message or handle it as needed
                        return; // Prevent form submission
                    }
                }

                // Check if capturedImageBlob is empty
                if (!this.capturedImageBlob) {
                    this.modalMessage = 'Please capture or upload an image.';
                    this.showModal = true; // Show the modal
                    return; // Do not proceed with form submission
                }

                // Check for signature fields with data
                const signatureFields = this.formFields.filter(field => field.type === 'SIGNATURE');
                
                const hasSignature = signatureFields.some(field => {
                    try {
                        const canvas = this.$refs[`signature_${field.id}`]?.[0];
                        if (!canvas) {
                            return false;
                        }
                        
                        const ctx = canvas.getContext('2d');
                        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                        const hasDrawing = imageData.data.some(channel => channel !== 0);
                        
                        return hasDrawing;
                    } catch (error) {
                        return false;
                    }
                });

                if (hasSignature) {
                    // Check if any signature fields have data but the blob isn't ready yet
                    for (const field of signatureFields) {
                        const canvas = this.$refs[`signature_${field.id}`]?.[0];
                        if (canvas && canvas.getContext('2d').getImageData(0, 0, canvas.width, canvas.height).data.some(channel => channel !== 0)) {
                            // There's drawing data on the canvas
                            // Check if we have either a blob in signatureData or base64 string in formData
                            const hasSignatureData = !!this.signatureData[field.id];
                            const hasBase64Data = typeof this.formData[field.inputName] === 'string' && 
                                                 this.formData[field.inputName].length > 100; // Base64 data should be substantial
                            
                            if (!hasSignatureData && !hasBase64Data) {
                                // Wait a moment to ensure conversion is complete (500ms)
                                await new Promise(resolve => setTimeout(resolve, 500));
                                
                                // Check again after waiting
                                const hasDataAfterWait = !!this.signatureData[field.id];
                                const hasBase64AfterWait = typeof this.formData[field.inputName] === 'string' && 
                                                         this.formData[field.inputName].length > 100;
                                
                                if (!hasDataAfterWait && !hasBase64AfterWait) {
                                    // Try to create the data on the spot as a last resort
                                    try {
                                        const dataURL = canvas.toDataURL('image/png', 1.0);
                                        const base64Data = dataURL.split(',')[1];
                                        
                                        if (base64Data && base64Data.length > 100) {
                                            this.formData[`input_${field.id}`] = base64Data;
                                            
                                            // Also create a blob for preview
                                            const binaryString = atob(base64Data);
                                            const array = [];
                                            for (let i = 0; i < binaryString.length; i++) {
                                                array.push(binaryString.charCodeAt(i));
                                            }
                                            
                                            const blob = new Blob([new Uint8Array(array)], {type: 'image/png'});
                                            this.signatureData[field.id] = blob;
                                        } else {
                                            throw new Error('Failed to create valid base64 data');
                                        }
                                    } catch (lastResortError) {
                                        this.modalMessage = 'Processing signature data, please try again in a moment.';
                                        this.showModal = true;
                                        return;
                                    }
                                }
                            }
                        }
                    }
                }

                this.isLoading = true; // Set loading state to true
                // Create a new FormData object
                const formData = new FormData();

                // Generate a unique filename for the captured image
                const timestamp = new Date().getTime(); // Get current timestamp
                const randomString = Math.random().toString(36).substring(7); // Generate a random string
                const uniqueFileName = `welcome_${timestamp}_${randomString}.png`;

                // Store original in R2 and submit the captured image (already blurred in croppa)
                // capturedImageBlob is always PNG from canvas — always compress to JPEG for GF upload
                const submitFileName = uniqueFileName.replace(/\.png$/, '.jpg');
                if (this.capturedImageBlob) {
                    // Use original (pre-blur) image for R2 storage so we keep the true original
                    const r2SourceBlob = this.originalImageBlob || this.capturedImageBlob;
                    try {
                        // Compress to JPEG before sending (PNG can be 3-8MB, JPEG ~200-500KB)
                        // This prevents exceeding Netlify's 6MB function payload limit
                        const compressedBlob = await this.compressBlobForUpload(r2SourceBlob);
                        const base64Data = await this.blobToBase64ForUpload(compressedBlob);
                        const blurResponse = await axios.post('/.netlify/functions/blur-and-store', {
                            imageBase64: base64Data,
                            fileName: uniqueFileName,
                            metadata: {
                                formId: this.formID,
                                submittedAt: new Date().toISOString(),
                            }
                        }, {
                            timeout: 22000 // 22s timeout (function has 26s, leave margin)
                        });
                        if (blurResponse.data.success) {
                            console.log(`R2 uploaded: ${blurResponse.data.r2Uploaded}, plates detected: ${blurResponse.data.platesDetected}`);
                        }
                    } catch (blurError) {
                        console.warn('R2 upload/blur failed, submitting captured image:', blurError);
                    }
                    // Compress capturedImageBlob (PNG) to JPEG for Gravity Forms — GF requires JPEG/allowed types
                    const imageToSubmit = await this.compressBlobForUpload(this.capturedImageBlob);
                    if (imageToSubmit) {
                        formData.append('input_13', imageToSubmit, submitFileName);
                    }
                }
                
                this.formFields.forEach(field => {
                    if (field.inputName) {
                        if (field.type === 'SIGNATURE') {
                            try {
                                // Get the canvas element
                                const canvas = this.$refs[`signature_${field.id}`]?.[0];
                                if (canvas) {
                                    const ctx = canvas.getContext('2d');
                                    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                                    const hasDrawing = imageData.data.some(channel => channel !== 0);
                                    
                                    if (hasDrawing) {
                                        // Try multiple submission formats to ensure compatibility
                                        const dataURL = canvas.toDataURL('image/png', 1.0);
                                        const base64Data = dataURL.split(',')[1];
                                        
                                        // Primary submission format - full data URL
                                        formData.append(field.inputName, dataURL);
                                        
                                        // Alternative formats that might be expected
                                        formData.append(`${field.inputName}_base64`, base64Data);
                                        formData.append(`gf_signature_${field.id}`, base64Data);
                                        
                                        // Also try submitting as a blob with proper filename
                                        try {
                                            const binaryString = atob(base64Data);
                                            const array = [];
                                            for (let i = 0; i < binaryString.length; i++) {
                                                array.push(binaryString.charCodeAt(i));
                                            }
                                            const blob = new Blob([new Uint8Array(array)], {type: 'image/png'});
                                            
                                            const timestamp = new Date().getTime();
                                            const randomString = Math.random().toString(36).substring(7);
                                            const uniqueSignatureFileName = `signature_${field.id}_${timestamp}_${randomString}.png`;
                                            
                                            formData.append(`${field.inputName}_file`, blob, uniqueSignatureFileName);
                                        } catch (blobError) {
                                            // Blob creation failed, continue with base64 only
                                        }
                                    } else {
                                        formData.append(field.inputName, '');
                                    }
                                } else {
                                    formData.append(field.inputName, '');
                                }
                            } catch (error) {
                                formData.append(field.inputName, '');
                            }
                        } else if (field.type === 'CONSENT') {
                            // For consent fields, send '1' if checked, empty string if not
                            const consentValue = this.formData[field.inputName] ? '1' : '';
                            formData.append(field.inputName, consentValue);
                        } else {
                            formData.append(field.inputName, this.formData[field.inputName] || '');
                        }
                    }
                });
                
                // Define the API endpoint URL
                const apiUrl = `https://engagr.driveagent.io/wp-json/gf/v2/forms/${this.formID}/submissions`;

                // Create an object with your credentials
                const credentials = {
                    username: 'ck_9eb5fc380da548b29cd454ad4e4e40edbf6f8aad', // Replace with your consumer key
                    password: 'cs_15706f39bc2a94c26ad71e695a2e730e29f6a7ae', // Replace with your consumer secret
                };

                // Encode the credentials in base64
                const base64Credentials = btoa(`${credentials.username}:${credentials.password}`);

                // Set up the headers with the Authorization header
                const headers = {
                    'Authorization': `Basic ${base64Credentials}`,
                };
                
                try {
                    await axios.post(apiUrl, formData, { headers });

                    this.clearForm(); // Clear the form fields

                    this.$emit('form-success');

                    this.modalMessage = 'Form submitted successfully.';
                    this.showModal = true;

                } catch (error) {
                    let errorMessage = 'Form submission failed. ';
                    
                    if (error.response) {
                        // Server responded with error status
                        if (error.response.status === 400) {
                            errorMessage += 'Please check that all required fields are filled correctly.';
                        } else {
                            errorMessage += `Server error: ${error.response.status}`;
                        }
                    } else if (error.request) {
                        // Request was made but no response received
                        errorMessage += 'No response from server. Please check your connection.';
                    } else {
                        // Something else happened
                        errorMessage += error.message;
                    }
                    
                    this.modalMessage = errorMessage;
                    this.showModal = true;
                }
            } catch (outerError) {
                this.modalMessage = 'An unexpected error occurred. Please try again.';
                this.showModal = true;
            } finally {
                this.isLoading = false;
                this.isSubmitting = false;
            }
        },

        clearForm() {
            // Clear form fields
            for (const key in this.formData) {
                this.formData[key] = '';
            }
            
            // Clear all signature canvases and signature data
            const signatureFields = this.formFields.filter(field => field.type === 'SIGNATURE');
            signatureFields.forEach(field => {
                try {
                    const canvas = this.$refs[`signature_${field.id}`]?.[0];
                    if (canvas) {
                        const ctx = canvas.getContext('2d');
                        ctx.clearRect(0, 0, canvas.width, canvas.height);
                    }
                    
                    // Clear signature data
                    delete this.signatureData[field.id];
                } catch (error) {
                    // Error clearing signature field
                }
            });
        },

        handleFileUpload() {
            // Handle file upload for the specific field
            const file = this.$refs.fileInput.files[0];
            if (file) {
                // Process the file and store it in this.formData[databaseId]
            }
        },
        isRequiredField(label) {
            // Define a list of field labels that should be required
            const requiredFields = ['Buyers Name', 'Buyers Email', 'Salesperson Name', 'Consent'];

            // Check if the current label is in the list of required fields
            return requiredFields.includes(label);
        },
        blobToBase64ForUpload(blob) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    const base64 = reader.result.split(',')[1];
                    resolve(base64);
                };
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        },
        base64ToBlob(base64, contentType = 'image/jpeg') {
            const byteCharacters = atob(base64);
            const byteArrays = [];
            for (let offset = 0; offset < byteCharacters.length; offset += 512) {
                const slice = byteCharacters.slice(offset, offset + 512);
                const byteNumbers = new Array(slice.length);
                for (let i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }
                byteArrays.push(new Uint8Array(byteNumbers));
            }
            return new Blob(byteArrays, { type: contentType });
        },
        compressBlobForUpload(blob) {
            if (!blob) return Promise.resolve(null);
            return new Promise((resolve) => {
                const img = new Image();
                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    canvas.width = img.width;
                    canvas.height = img.height;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0);
                    canvas.toBlob((jpegBlob) => {
                        if (jpegBlob) {
                            URL.revokeObjectURL(img.src);
                            resolve(jpegBlob);
                        } else {
                            URL.revokeObjectURL(img.src);
                            resolve(blob); // fallback to original
                        }
                    }, 'image/jpeg', 0.85);
                };
                img.onerror = () => {
                    URL.revokeObjectURL(img.src);
                    resolve(blob); // fallback to original on error
                };
                img.src = URL.createObjectURL(blob);
            });
        },
        emitOpenModal() {
            this.$emit('open-modal'); // Emit a custom event named 'open-modal'
        },
        validateEmail(email) {
            const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
            return emailPattern.test(email);
        },
        validateEmailOnBlur(emailValue, fieldType) {
            if (fieldType === 'EMAIL') {
                const isValidEmail = this.validateEmail(emailValue);
                if (!isValidEmail) {
                    this.emailValidation.isValid = false;
                    this.emailValidation.message = 'Invalid email format'; // Optional error message
                } else {
                    // Clear the error message and set emailValidation to valid
                    this.emailValidation.isValid = true;
                    this.emailValidation.message = ''; // Clear the error message
                }
            }
        },
        
        // Handle window resize to ensure canvas is properly sized
        handleWindowResize() {
            // Debounce the resize handler to avoid excessive processing
            if (this.resizeTimeout) {
                clearTimeout(this.resizeTimeout);
            }
            
            this.resizeTimeout = setTimeout(() => {
                // Find all signature fields and reinitialize their canvases
                const signatureFields = this.formFields.filter(field => field.type === 'SIGNATURE');
                
                signatureFields.forEach(field => {
                    try {
                        const canvas = this.$refs[`signature_${field.id}`]?.[0];
                        if (canvas) {
                            const ctx = canvas.getContext('2d');
                            const currentWidth = canvas.offsetWidth;
                            const currentHeight = canvas.offsetHeight;
                            
                            // Check if dimensions have changed
                            if (parseInt(canvas.dataset.width) !== currentWidth || 
                                parseInt(canvas.dataset.height) !== currentHeight) {
                                
                                // Save current drawing if any
                                let imageData = null;
                                try {
                                    imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                                } catch (e) {
                                    // Error saving canvas content during resize
                                }
                                
                                // Set new dimensions with device pixel ratio for better quality
                                const dpr = window.devicePixelRatio || 1;
                                canvas.width = currentWidth * dpr;
                                canvas.height = currentHeight * dpr;
                                
                                // Scale context according to device pixel ratio
                                ctx.scale(dpr, dpr);
                                
                                // Store dimensions in dataset
                                canvas.dataset.width = currentWidth;
                                canvas.dataset.height = currentHeight;
                                
                                // Restore drawing if there was any
                                if (imageData) {
                                    try {
                                        ctx.putImageData(imageData, 0, 0);
                                    } catch (e) {
                                        // Error restoring canvas content after resize
                                    }
                                }
                                
                                // Reset drawing styles
                                ctx.strokeStyle = '#000000';
                                ctx.lineWidth = 2;
                                ctx.lineCap = 'round';
                                ctx.lineJoin = 'round';
                            }
                        }
                    } catch (error) {
                        // Error handling resize for signature field
                    }
                });
            }, 250); // 250ms debounce
        },

        // Signature drawing methods
        startDrawing(event, fieldId) {
            this.isDrawing = true;
            this.currentFieldId = fieldId;
            
            const canvas = this.$refs[`signature_${fieldId}`][0];
            const rect = canvas.getBoundingClientRect();
            const ctx = canvas.getContext('2d');
            
            // Initialize canvas size only once or if dimensions have changed
            const currentWidth = canvas.offsetWidth;
            const currentHeight = canvas.offsetHeight;
            
            if (!canvas.dataset.initialized || 
                parseInt(canvas.dataset.width) !== currentWidth || 
                parseInt(canvas.dataset.height) !== currentHeight) {
                
                // Save current drawing if any
                let imageData = null;
                if (canvas.dataset.initialized) {
                    try {
                        imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                    } catch (e) {
                        // Error saving canvas content during resize
                    }
                }
                
                // Set new dimensions with device pixel ratio for better quality
                const dpr = window.devicePixelRatio || 1;
                canvas.width = currentWidth * dpr;
                canvas.height = currentHeight * dpr;
                
                // Scale context according to device pixel ratio
                ctx.scale(dpr, dpr);
                
                // Store dimensions in dataset
                canvas.dataset.width = currentWidth;
                canvas.dataset.height = currentHeight;
                canvas.dataset.initialized = 'true';
                
                // Restore drawing if there was any
                if (imageData) {
                    try {
                        ctx.putImageData(imageData, 0, 0);
                    } catch (e) {
                        // Error restoring canvas content after resize
                    }
                }
            }
            
            // Set drawing styles
            ctx.strokeStyle = '#000000';
            ctx.lineWidth = 2;
            ctx.lineCap = 'round';
            ctx.lineJoin = 'round';
            
            // Get coordinates, accounting for touch events
            let x, y;
            if (event.type.startsWith('touch')) {
                if (!event.touches || !event.touches[0]) {
                    return;
                }
                x = event.touches[0].clientX - rect.left;
                y = event.touches[0].clientY - rect.top;
            } else {
                x = event.clientX - rect.left;
                y = event.clientY - rect.top;
            }
            
            ctx.beginPath();
            ctx.moveTo(x, y);
            
            event.preventDefault();
        },

        draw(event, fieldId) {
            if (!this.isDrawing || this.currentFieldId !== fieldId) return;
            
            const canvas = this.$refs[`signature_${fieldId}`][0];
            if (!canvas) {
                return;
            }
            
            const rect = canvas.getBoundingClientRect();
            const ctx = canvas.getContext('2d');
            
            // Get coordinates, accounting for touch events
            let x, y;
            if (event.type.startsWith('touch')) {
                if (!event.touches || !event.touches[0]) {
                    return;
                }
                x = event.touches[0].clientX - rect.left;
                y = event.touches[0].clientY - rect.top;
            } else {
                x = event.clientX - rect.left;
                y = event.clientY - rect.top;
            }
            
            ctx.lineTo(x, y);
            ctx.stroke();
            
            event.preventDefault();
        },

        stopDrawing(fieldId) {
            if (this.isDrawing && this.currentFieldId === fieldId) {
                this.isDrawing = false;
                this.currentFieldId = null;
                
                // Save signature data
                const canvas = this.$refs[`signature_${fieldId}`][0];
                
                // Ensure canvas has content before attempting conversion
                const ctx = canvas.getContext('2d');
                const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                const hasDrawing = imageData.data.some(channel => channel !== 0);
                
                if (!hasDrawing) {
                    return;
                }
                
                // Use a more reliable approach for signature data storage
                try {
                    // First convert to data URL with high quality
                    const dataURL = canvas.toDataURL('image/png', 1.0);
                    
                    // Store both the full dataURL and the base64 part
                    const base64Data = dataURL.split(',')[1];
                    
                    // Then convert data URL to blob for preview purposes
                    const binaryString = atob(base64Data);
                    const array = [];
                    for (let i = 0; i < binaryString.length; i++) {
                        array.push(binaryString.charCodeAt(i));
                    }
                    
                    const blob = new Blob([new Uint8Array(array)], {type: 'image/png'});
                    
                    // Store the blob in signatureData for preview
                    this.signatureData[fieldId] = blob;
                    
                    // Store the complete data URL in formData for submission (what server expects)
                    this.formData[`input_${fieldId}`] = dataURL;
                    
                    // Also store just the base64 data as a backup
                    this.formData[`signature_base64_${fieldId}`] = base64Data;
                    
                    // Try additional formats that the Gravity Forms Signature plugin might expect
                    this.formData[`gf_signature_${fieldId}`] = base64Data;
                    this.formData[`signature_${fieldId}`] = base64Data;
                    this.formData[`input_signature_${fieldId}`] = base64Data;
                    
                    // Try with the format that might be used for file uploads
                    const signatureFileName = `signature_${fieldId}_${new Date().getTime()}.png`;
                    this.formData[`input_${fieldId}_file`] = base64Data;
                    // Store the filename for later use
                    this.formData[`input_${fieldId}_filename`] = signatureFileName;
                    
                    // Update the preview immediately
                    this.$forceUpdate();
                } catch (error) {
                    // Error in signature processing
                }
            }
        },

        clearSignature(fieldId) {
            const canvas = this.$refs[`signature_${fieldId}`][0];
            const ctx = canvas.getContext('2d');
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            
            // Clear signature data
            delete this.signatureData[fieldId];
            this.formData[`input_${fieldId}`] = '';
        },

        // Toggle consent accordion
        toggleConsentAccordion(fieldId) {
            this.$set(this.consentAccordionOpen, fieldId, !this.consentAccordionOpen[fieldId]);
        },
        
        // Helper method to display signature preview
        getSignaturePreview(fieldId) {
            if (this.signatureData[fieldId] && this.signatureData[fieldId] instanceof Blob) {
                try {
                    // Create a URL for the blob
                    const url = URL.createObjectURL(this.signatureData[fieldId]);
                    return url;
                } catch (error) {
                    // Fallback: try to get a data URL directly from the canvas
                    try {
                        const canvas = this.$refs[`signature_${fieldId}`]?.[0];
                        if (canvas) {
                            return canvas.toDataURL('image/png');
                        }
                    } catch (canvasError) {
                        // Fallback canvas preview failed
                    }
                }
            } else if (this.$refs[`signature_${fieldId}`]?.[0]) {
                // If no blob is available but we have a canvas with content, use that
                try {
                    const canvas = this.$refs[`signature_${fieldId}`][0];
                    const ctx = canvas.getContext('2d');
                    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                    const hasDrawing = imageData.data.some(channel => channel !== 0);
                    
                    if (hasDrawing) {
                        return canvas.toDataURL('image/png');
                    }
                } catch (error) {
                    // Error creating canvas data URL for preview
                }
            }
            
            return '';
        }
    },
    mounted() {
        this.fetchData();
        
        // Add window resize listener to handle canvas resizing
        window.addEventListener('resize', this.handleWindowResize);
    },
    beforeDestroy() {
        // Clean up event listener
        window.removeEventListener('resize', this.handleWindowResize);

        // Revoke cached captured image URL
        if (this.capturedImageUrl) {
            URL.revokeObjectURL(this.capturedImageUrl);
        }

        // Clean up any object URLs to prevent memory leaks
        for (const fieldId in this.signatureData) {
            if (this.signatureData[fieldId] instanceof Blob) {
                try {
                    URL.revokeObjectURL(this.getSignaturePreview(fieldId));
                } catch (error) {
                    // Error revoking URL for field
                }
            }
        }
    },
};
</script>
<style scoped>
/* Remove browser's autocomplete background color */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active,
input:-webkit-autofill::first-line,
input:-webkit-autofill:focus::first-line {
    -webkit-text-fill-color: currentColor;
    -webkit-box-shadow: 0 0 0 30px transparent inset !important;
}

body input:autofill,
body input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px transparent inset;
    box-shadow: 0 0 0px 1000px transparent inset;
}

input:-webkit-autofill {
    transition-delay: 9999s;
    transition-property: background-color, color;
}

input[type="radio"]:checked+label svg {
    display: block !important;
}

input {
    font-size: 16px;
}

[for="RADIO"] {
    margin-top: 2px;
    color: #2863eb;
    font-size: 20px;
    font-weight: 700;
}

/* Signature field styles */
.signature-field {
    margin-top: 1rem;
}

.signature-canvas {
    background-color: #fafafa;
    touch-action: none;
}

.signature-canvas:hover {
    border-color: #3b82f6;
}

.signature-canvas:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

/* Consent content HTML styling */
.consent-content ul {
    list-style-type: disc;
    margin-left: 1.5rem;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
}

.consent-content ol {
    list-style-type: decimal;
    margin-left: 1.5rem;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
}

.consent-content li {
    margin-bottom: 0.25rem;
    line-height: 1.5;
}

.consent-content strong {
    font-weight: 600;
}

.consent-content br {
    line-height: 1.5;
}

/* Background image subtle zoom animation */
@keyframes subtle-zoom {
    0% { transform: scale(1); }
    50% { transform: scale(1.05); }
    100% { transform: scale(1); }
}

.bg-image-animate {
    animation: subtle-zoom 30s ease-in-out infinite;
}
</style>
